export default __webpack_public_path__ + "static/media/form-otp.bc33f624.svg";